<div class="gadget-settings-component-container">

  <swiper-container #mainSwiper class="main-swiper" [allowTouchMove]="false" [simulateTouch]="false">

    <!-- Slide 1: Gadget Settings Form -->
    <swiper-slide class="main-slide">
      <div class="slide-in-settings-section">

        <p class="slide-in-settings-header-text">{{ 'Gadget Settings' | translate }}</p>

      </div>

      <div class="slide-in-settings-section">
        <mat-form-field class="contact-info-input" appearance="fill">
          <input [disabled]="!canEdit" type="text" [(ngModel)]="clonedGadgetComplete.gadgetLanguage.name"
            maxlength="320" (touchend)="$event.stopPropagation()" matInput>
        </mat-form-field>
      </div>

      <!-- Owner Dropdown Removed as per user request -->

      <div class="slide-in-settings-section">
        <div class="flex-list-item card-container" [ngClass]="{'card-container-no-hover-effect': !canEdit}">
          <img (click)="canEdit ? onImageClick() : null" [class.clickable]="canEdit" class="card-image"
            [src]="getDisplayImage()">
        </div>
      </div>

      <div *ngIf="canEdit" class="slide-in-settings-section row">
        <button (click)="updateGadgetSettings()" class="full-width-mobile mat-primary-lighter"
          mat-buttonclass="rectangle-btn" mat-raised-button color="primary">{{ 'Update Gadget' | translate }}</button>
        <button (click)="deleteGadget()" class="full-width-mobile" mat-buttonclass="rectangle-btn" mat-raised-button
          color="warn">{{ 'Delete Gadget' | translate }}</button>
      </div>
    </swiper-slide>

    <!-- Slide 2: Image selection options -->
    <swiper-slide class="photo-slide">
      <app-photo-selector [selectedCuratedImageUrl]="selectedCuratedImage"
        [existingFileUpload]="clonedGadgetComplete?.iconFileUploadComplete?.fileUpload"
        [backButtonCallback]="returnToFirstSlide.bind(this)" (imageSelected)="onCuratedImageSelected($event)"
        (imageUploaded)="onImageUploaded($event)">
      </app-photo-selector>
    </swiper-slide>

  </swiper-container>

</div>